export const productionEnvConfig = {
  DISABLED_CONSOLE_MSG: false,
  // YOLO_BASE_URL: 'https://www.yolorekt.finance',
  YOLO_BASE_URL: 'https://www.yolorekt.finance',

  BASE_BRANCH: '',

  WSB_REFERRAL_CODE: 'WSB',

  // CRYPTO
  APPROVED_CHAINS_IDS: [137],

  //BACKEND CONNECTION
  YOLO_API_BASE_URL: 'https://api.eu.prod.sproutsy.farm', //https://api.prod-eu.yolorekt.finance', //'https://api.prod.yolorekt.finance',
  BACKEND_SOCKET_URL: 'wss://feed-server.sproutsy.farm/',
  GATEWAY_SOCKET_URL: 'wss://api.eu.prod.leverage-gateway.sproutsy.farm/',
  CONTRACTS_VERSION: '35',
}
